var map = {
	"./basic.svg": 49,
	"./basil.svg": 107,
	"./dough.svg": 108,
	"./greenPepper.svg": 109,
	"./mushrooms.svg": 110,
	"./olives.svg": 111,
	"./onion.svg": 112,
	"./pineapple.svg": 113,
	"./redPepper.svg": 114,
	"./salami.svg": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;